import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LangProvider } from "./i18n/LangContext";
import { AuthProvider } from "./lib/auth";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import LegalPage from "./pages/LegalPage";
import BrandKit from "./pages/BrandKit";
import Admin from "./pages/Admin";
import AdminVisuals from "./pages/AdminVisuals";
import AdminLogin from "./pages/AdminLogin";
import { CookieBanner } from "./components/CookieBanner";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/mentions-legales" element={<LegalPage />} />
            <Route path="/confidentialite" element={<LegalPage />} />
            <Route path="/brand" element={<BrandKit />} />
            <Route path="/admin/login" element={<AuthProvider><AdminLogin /></AuthProvider>} />
            <Route path="/admin" element={<AuthProvider><Admin /></AuthProvider>} />
            <Route path="/admin/visuals" element={<AuthProvider><AdminVisuals /></AuthProvider>} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </LangProvider>
    </div>
  );
}

export default App;
